import head from 'lodash/head';

export class GoogleLocationService {
    constructor($resource, $timeout, ApiService) {
        'ngInject';

        const placeDetailsResourceUrl = ApiService.getResourceUrl('place/details');
        this.placeDetailsResource = $resource(placeDetailsResourceUrl);
        this.$timeout = $timeout;
    }

    getLocationObject(details) {
        let addressDetails = {};
        details.address_components.map((data) => {
            let type = head(data.types);
            switch (type) {
                case 'administrative_area_level_1':
                    addressDetails.stateName = data.long_name;
                    addressDetails.stateCode = data.short_name;
                    break;
                case 'administrative_area_level_2':
                    addressDetails.countyName = data.long_name;
                    break;
                case 'administrative_area_level_3':
                    addressDetails.townName = data.long_name;
                    break;
                case 'locality':
                    addressDetails.villageName = data.long_name;
                    break;
                case 'neighborhood':
                    addressDetails.townshipName = data.long_name;
                    break;
                case 'country':
                    addressDetails.countryCode = data.short_name;
                    break;
            }
        });
        addressDetails.latlng = {
            lat: typeof details.geometry.location.lat === 'function' 
                ? details.geometry.location.lat()
                : details.geometry.location.lat,
            lng: typeof details.geometry.location.lng === 'function'
                ? details.geometry.location.lng()
                : details.geometry.location.lng
        };
        // addressDetails.name = !addressDetails.name ? details.name ? details.name : details.formatted_address : addressDetails.name;

        return addressDetails;
    }

    getLocationDetailsByPlaceName(placeName) {
        let geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {
            this.$timeout(() => {
                geocoder.geocode({ 'address': placeName }, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        const placeShortName = this._getPlaceShortName(placeName);
                        resolve({ placeName, placeShortName, results });
                    } else {
                        reject();
                    }
                });
            }, 800);
        });
    }

    getLocationDetailsByLatlng(latlng) {
        let geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {
            geocoder.geocode({ 'location': latlng }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results);
                }
            });
        });
    }

    getPlaceDetailsByText(text) {
        return this.placeDetailsResource.get({
            text
        }).$promise.then(placeDetails => {
            return placeDetails.data;
        });
    }

    _getPlaceShortName(placeName) {
        const index = placeName.indexOf(',');
        return placeName.slice(0, index);
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/google-location/google-location.service.js